module.exports = __webpack_public_path__ + "static/img/banner2.9810a31.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/contact/banner2.png
// module id = u4DF
// module chunks = 0